module.exports = __webpack_public_path__ + "static/media/seal.e9d398e7.svg";